import React, { lazy, Suspense } from 'react';
export var CONFLUENCE_SEARCH_DATASOURCE_ID = '768fc736-3af4-4a8f-b27e-203602bff8ca';
var LazyConfluenceSearchConfigModal = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-confluencesearchmodal" */'./modal').then(function (module) {
    return {
      default: module.ConfluenceSearchConfigModal
    };
  });
});
var ConfluenceSearchConfigModalWithWrappers = function ConfluenceSearchConfigModalWithWrappers(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      "data-testid": 'confluence-search-datasource-table-suspense'
    })
  }, /*#__PURE__*/React.createElement(LazyConfluenceSearchConfigModal, props));
};
export default ConfluenceSearchConfigModalWithWrappers;